import {Injectable} from '@angular/core';
import {CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router} from '@angular/router';
import {Observable} from 'rxjs/Observable';
import {AuthService} from "./auth.service";

@Injectable()
export class CanActivateViaAuthGuard implements CanActivate {

  constructor(private authService: AuthService, private router: Router) {

  }

  canActivate(next: ActivatedRouteSnapshot,
              state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    //console.log("canActivate?");
    if (this.authService.isLoggedIn()) {
      //console.log("canActivate=true");
      return true;
    }
    //console.log("canActivate=false");
    this.router.navigate(['/login'], {queryParams: {returnUrl: state.url}});
    return false;
  }
}



// WEBPACK FOOTER //
// ./src/app/can-activate-via-auth.guard.ts